function Search() {
  const $body = $('body');
  const $document = $(document);
  const $widgetForm = $('[data-widget="search-form"]');

  const init = () => {
    handleSearch();
    handleSubmit();
  };



  const handleSearch = () => {
    $document.on('click', (e) => {
      const $e = $(e.target);
      const $isSearchWidget = $e.closest('[data-widget="search"]').length > 0;
      const $isOpen = $body.hasClass('search-opened');
      const $isForm = $e.closest('.header-search-area').length > 0;
      
      if (!$isOpen && $isSearchWidget) {
        $body.addClass('search-opened');
        $widgetForm.find('input').focus();
      }

      if ($isOpen && !$isForm)
        $body.removeClass('search-opened');
    });
  };
  const handleSubmit = () => {
    $widgetForm.on('submit', (event) => {
      event.preventDefault();
      const formData = new FormData(event.currentTarget as HTMLFormElement);
      const value = formData.get('search');

      if (!value) return;

      fnGoToSearch(value as string);
    });
  };

  const fnGoToSearch = (text: string) => {
    window.location.href = `/busca?ft=${removeChars(text)}`;
  };

  const removeChars = (str: string) => {
    const re = new RegExp('[\'"%#&*+()|<>\\/?]', 'g');
    return str.replace(re, ' ').trim();
  };
  init();
}

window.aguadecoco = window.aguadecoco || {};
Object.assign(window.aguadecoco, {
  widgets: Object.assign(window.aguadecoco.widgets || {}, {
    search: new Search(),
  }),
});

export default {};
